import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocumentService, UserService } from '@app/shared/services';
import { NotifyAPIUpdateService } from '@app/shared/services/notify-api-update/notify-api-update.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AddApiRapidValueService } from '../../add-api-rapid-value.service';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'add-edit-motor-value',
  templateUrl: './add-edit-motor-value.component.html',
  styleUrls: ['./add-edit-motor-value.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddEditMotorValueComponent implements OnInit, OnDestroy {
  @Input() inlineComponent = false;
  @Input() inlineData;
  @Output() updateEvent = new EventEmitter<any>();
  @Output() actionEvent = new EventEmitter<any>();

  vehicleForm: UntypedFormGroup;
  isFetchedData = false;
  is_loading = false;
  is_active_connection = false;

  payload;
  currentFormId;
  isFetchingData = false;
  subscription = new Subscription();

  isVehicleLicensePlate: boolean = false;
  isVehicleDetails: boolean = false;

  isUpdateVehicleDetailsInfo: boolean = false;

  toggleValue: boolean = false;
  dialogRef;
  response;
  yearList = [];
  stepNumber = 1;
  markOwnerAsComplete = false;
  // ValueEstimateTypeList = [
  //   {
  //     value: 'Trade-In',
  //     label: 'Trade-In',
  //   },
  //   {
  //     value: 'Private Party',
  //     label: 'Private Party',
  //   },
  //   {
  //     value: 'Dealer Retail',
  //     label: 'Dealer Retail',
  //   },
  // ];
  // conditionList = [
  //   {
  //     value: 'Outstanding',
  //     label: 'Outstanding',
  //   },
  //   {
  //     value: 'Clean',
  //     label: 'Clean',
  //   },
  //   {
  //     value: 'Average',
  //     label: 'Average',
  //   },
  //   {
  //     value: 'Rough',
  //     label: 'Rough',
  //   },
  // ];
  // trimList = [];

  constructor(
    private formBuilder: UntypedFormBuilder,

    private cd: ChangeDetectorRef,
    private injector: Injector,
    private toastr: ToastrService,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data,
    private _documentService: DocumentService,
    private addApiRapidValueService: AddApiRapidValueService,
    private _notifyAPIUpdateService: NotifyAPIUpdateService
  ) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  ngOnInit(): void {
    if (this.inlineComponent) {
      this.data = this.inlineData;
    } else {
      this.dialogRef = this.injector.get(MatDialogRef<AddEditMotorValueComponent>);
    }

    this.currentFormId = this.data.currentFormId;

    // if (this.data?.formSetupData && this.data.formSetupData?.status) {
    //   this.markOwnerAsComplete = this.data.formSetupData.status === 'complete' ? true : false;
    // }

    if (this.data.is_edit) {
      this.isVehicleDetails = true;
      this.toggleValue = true;
    }
    // for (let year = 1981; year <= 2023; year++) {
    //   this.yearList.push({ value: year.toString(), label: year.toString() });
    // }

    // this.vehicleForm = this.formBuilder.group({
    //   year: ['', Validators.required],
    //   make: ['', Validators.required],
    //   model: ['', Validators.required],
    //   trim: ['', Validators.required],
    //   condition: ['Outstanding', Validators.required],
    //   type: ['Trade-In', Validators.required],
    //   estimateValue: ['', Validators.required],
    //   vin: ['', Validators.required],
    // });
    // if (this.data?.is_edit) {
    //   this.is_active_connection = true;
    //   this.vehicleForm.setValue(this.data.motor.setting);
    //   this.payload = this.data.motor.payload;
    //   this.response = this.data.motor.response;
    //   this.isFetchedData = true;
    //   this.isFetchingData = false;
    //   this.cd.detectChanges();
    //   try {
    //     let trimList = this.response.data.market_value.market_value_data.map((x) => x.trim);
    //     trimList.forEach((element, index) => {
    //       if (index == 0) {
    //         this.vehicleForm.controls.trim.setValue(element);
    //       }
    //       this.trimList.push({
    //         value: element,
    //         label: element,
    //       });
    //     });
    //   } catch (error) {}
    // }
  }

  // onValueChange(newValue: string) {
  //   // Handle value change here
  //   console.log('New value:', newValue);
  // }

  // fetchSave() {
  //   if (!this.isFetchedData) {
  //     this.isFetchingData = true;
  //     const data = {
  //       year: this.vehicleForm.controls.year.value,
  //       model: this.vehicleForm.controls.model.value,
  //       make: this.vehicleForm.controls.make.value,
  //     };
  //     this.subscription.add(
  //       this.userService.getCarDetails(data).subscribe((res) => {
  //         if (res.status == 'error') {
  //           this.isFetchingData = false;
  //           this.toastr.warning('sorry! we are not able to find vehicle');
  //           this.cd.detectChanges();
  //           return;
  //         }
  //         this.payload = data;
  //         this.response = res;
  //         this.isFetchedData = true;
  //         this.isFetchingData = false;
  //         this.cd.detectChanges();
  //         try {
  //           let trimList = res.data.market_value.market_value_data.map((x) => x.trim);
  //           trimList.forEach((element, index) => {
  //             if (index == 0) {
  //               this.vehicleForm.controls.trim.setValue(element);
  //             }
  //             this.trimList.push({
  //               value: element,
  //               label: element,
  //             });
  //           });
  //         } catch (error) {}
  //       })
  //     );
  //   } else {
  //     let setting = this.vehicleForm.value;
  //     try {
  //       setting.estimateValue = this.setEstimateValue(this.response, setting);
  //     } catch (error) {}
  //     const data = {
  //       vault_user_form_id: this.currentFormId,
  //       type: 'motor',
  //       status: 'connected',
  //       response: JSON.stringify(this.response),
  //       setting: JSON.stringify(setting),
  //       payload: JSON.stringify(this.payload),
  //     };

  //     this.subscription.add(
  //       this._documentService.createVaultFormMotorValutionIntegration(data).subscribe((res) => {
  //         this.dialogRef.close({
  //           success: true,
  //         });
  //         this.is_active_connection = true;
  //         this.cd.detectChanges();
  //       })
  //     );
  //   }
  // }

  // setEstimateValue(response, setting) {
  //   try {
  //     let trim = response.data.market_value.market_value_data.find((x) => x.trim == setting.trim);
  //     return trim['market value'].find((x) => x.Condition == setting.condition)[setting.type];
  //   } catch (error) {
  //     return '$0';
  //   }
  // }

  updateStepNumber(event) {
    this.stepNumber = event;
  }

  backArrow() {
    this.stepNumber = 1;
    this.cd.detectChanges();
  }

  closedialog() {
    if (this.inlineData) {
      this.actionEvent.emit({ success: false });
    } else {
      this.dialogRef.close({
        success: false,
        markOwnerAsComplete: this.markOwnerAsComplete,
      });
    }
  }

  onupdateVehicleDetailsInfo(flag: any) {
    if (this.inlineData || flag?.disconnect) {
      this.onReplaceConnection(true);
    } else {
      this.isUpdateVehicleDetailsInfo = flag;
    }
  }

  onToggleChange(event: any) {
    this.toggleValue = !this.toggleValue;
  }

  onReplaceConnection(flag: boolean) {
    if (flag) {
      this.is_loading = true;
      this.cd.detectChanges();
      this.subscription.add(
        this._documentService.deleteVaultFormRapidIntegration(this.currentFormId).subscribe((res) => {
          this.data.is_edit = false;
          this.isVehicleDetails = false;
          this.toggleValue = false;
          this.stepNumber = 1;
          this.setUpEditRemoveDataFrom();
          this.isUpdateVehicleDetailsInfo = false;
          this.markOwnerAsComplete = false;
          let status = 'created';
          this.addApiRapidValueService.setPropertyDataFromLiveFeeds({}, this.data?.templateId);
          this.addApiRapidValueService.vehicleDataSubjectData.next(null);
          this._notifyAPIUpdateService.sendAPIData({ status: status, subtype: 'VehicleDatabase' });
          this.is_loading = false;
          this.cd.detectChanges();
        })
      );
    } else {
      this.isUpdateVehicleDetailsInfo = false;
    }
  }

  setUpEditRemoveDataFrom() {
    this.data.apiMotorValueList.setting.year = '';
    this.data.apiMotorValueList.setting.make = '';
    this.data.apiMotorValueList.setting.condition = '';
    this.data.apiMotorValueList.setting.model = '';
    this.data.apiMotorValueList.setting.trim = '';
  }

  // onChange() {
  //   this.dialogRef.close({
  //     success: true,
  //   });
  // }

  onChange() {
    this.markOwnerAsComplete = !this.markOwnerAsComplete;
    let status = this.markOwnerAsComplete ? 'complete' : 'created';

    this._notifyAPIUpdateService.sendAPIData({ status: status, subtype: 'VehicleDatabase' });
    this.updateEvent.emit({ status: status, subtype: 'VehicleDatabase' });
    this.closedialog();
  }
}
